$(document).ready(function () {
    //tabs
    if ($(window).width() >= 480) {
        $('ul.tabs_caption').on('click', 'li:not(.active)', function () {
            $(this)
                .addClass('active').siblings().removeClass('active')
                .closest('div.tabs').find('div.tabs_content').removeClass('active').eq($(this).index()).addClass('active');
        });
    } else {
        $('ul.tabs_caption li').on('click', function () {
            if ($(this)['context'].className !== 'active') {
                $(this).addClass('active').siblings().removeClass('active')
                    .closest('div.tabs').find('div.tabs_content').removeClass('active').hide().eq($(this).index()).addClass('active').slideToggle();
            } else {
                $(this).removeClass('active').closest('div.tabs').find('div.tabs_content').eq($(this).index()).slideToggle();
            }
        });
    }
    //всплывающая подсказка
    $('.info-title').poshytip({
        className: 'tip-yellowsimple',
        showTimeout: 0.2,
        alignTo: 'target',
        alignX: 'center',
        offsetY: 5,
        allowTipHover: false
    });
    //checkbox карточка товара (такто можно через css)
    $('.checkbox').each(function () {
        if ($(this).find('input:checked').length) {
            $(this).addClass('checked');
        } else {
            $(this).removeClass('checked');
        }
    });
    $('.checkbox input').change(function () {
        if ($(this).is(':checked'))
            $(this).parent().addClass('checked');
        else
            $(this).parent().removeClass('checked');
    });
    //oneclickorder
    $("#one-click-order").click(function (e) {
        e.preventDefault();
        var $pageForm = $('.product-page form');
        var $fancyContent = $('<div class="one-click-buy"></div>');
        var $buttonRow = $('<div class="btn-row"></div>');
        var $form = $("<form></form>");
        $form.append('<input type="hidden" name="season" value="' + $pageForm.find('#CartItems_itemType').val() + '"/>');
        $form.append('<input type="hidden" name="itemId" value="' + $pageForm.find("#CartItems_itemId").val() + '" />');
        $form.append('<textarea name="oneClickText" placeholder="Чтобы заказать товар, напишите как с вами связаться (желательно телефон) и ваше имя"></textarea>');
        $buttonRow.append('<button type="submit" class="default-btn cart-btn" href="/catalog/cart"><span>Отправить</span></button>');
        $form.append($buttonRow);

        $form.submit(function (e) {
            e.preventDefault();
            var $formData = $(this);
            $.ajax({
                type: "POST",
                url: "/catalog/oneclickorder",
                dataType: 'json',
                data: $formData.serialize(),
                success: function (response) {
                    if (response.res !== 0) {
                        $.fancybox.close();
                        $.fancyboxNotify(
                            '<a style="top: 10px;right: 10px;" class="fancybox-close" onclick="$.fancybox.close();"></a>' +
                            '<p class="success_message">Спасибо за заказ!</p>' +
                            '<p>В ближайшее время с вами свяжется наш менеджер для уточнения деталей доставки и оплаты!</p>', 'Заказать в один клик', 'one-click_modal').open(true);
                        setTimeout(function () {
                            $.fancybox.close();
                        }, 5000);
                    } else {
                        $.each(response.err, function (idx, item) {
                            var $em = $('<p class="errorMessage">' + item + '</p>');
                            setTimeout(function () {
                                $em.fadeOut(300, function () {
                                    $(this).remove();
                                });
                            }, 3000);
                            $em.insertBefore($formData.find('.btn-row'));
                        });
                    }
                },
            });
        });
        $fancyContent.append($form);
        $.fancyboxNotify($fancyContent, 'Заказать в один клик', 'one-click_modal').open();
    });

    //карточка товара размер/бант/прорези
    $('.heatType, .autoChair, .size, .bowKnot').change(function () {
        var $heatType = $('.heatType:checked');
        var $autoChair = $('.autoChair');
        var $bowKnot = $('.bowKnot');
        var $size = $('.size:checked');
        var $priceContainer = $('.price-main');
        var price = parseInt($priceContainer.data('price'));
        var priceDiscounted = parseInt($priceContainer.data('pricediscounted'));
        var heatTypePrice = $heatType.data('price') || 0;
        var autoChairPrice = $autoChair.is(':checked') ? $autoChair.data('price') : 0;
        var bowKnotPrice = $bowKnot.is(':checked') ? $bowKnot.data('price') : 0;
        var sizePrice = $size.data('price');
        $priceContainer.find('.priceamount span').html(formatNumber(priceDiscounted + heatTypePrice + autoChairPrice + bowKnotPrice + sizePrice, 0, ',', ' ') + "&nbsp;₽");
        $priceContainer.find('.price_old span').html(formatNumber(price + heatTypePrice + autoChairPrice + bowKnotPrice + sizePrice, 0, ',', ' ') + "&nbsp;₽");
        $('#CatalogDelivery_cityId').trigger('change');
    });
});